var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3.25C14.044 3.25 17.4085 6.16 18.1143 10C17.4093 13.84 14.044 16.75 10 16.75C5.956 16.75 2.5915 13.84 1.88575 10C2.59075 6.16 5.956 3.25 10 3.25ZM10 15.25C11.5296 15.2497 13.0138 14.7301 14.2096 13.7764C15.4055 12.8226 16.2422 11.4912 16.5828 10C16.2409 8.50998 15.4037 7.18 14.208 6.22752C13.0122 5.27504 11.5287 4.7564 10 4.7564C8.47127 4.7564 6.98777 5.27504 5.79203 6.22752C4.5963 7.18 3.75908 8.50998 3.41725 10C3.75782 11.4912 4.59451 12.8226 5.79036 13.7764C6.98621 14.7301 8.4704 15.2497 10 15.25V15.25ZM10 13.375C9.10489 13.375 8.24645 13.0194 7.61352 12.3865C6.98058 11.7536 6.625 10.8951 6.625 10C6.625 9.10489 6.98058 8.24645 7.61352 7.61352C8.24645 6.98058 9.10489 6.625 10 6.625C10.8951 6.625 11.7536 6.98058 12.3865 7.61352C13.0194 8.24645 13.375 9.10489 13.375 10C13.375 10.8951 13.0194 11.7536 12.3865 12.3865C11.7536 13.0194 10.8951 13.375 10 13.375ZM10 11.875C10.4973 11.875 10.9742 11.6775 11.3258 11.3258C11.6775 10.9742 11.875 10.4973 11.875 10C11.875 9.50272 11.6775 9.02581 11.3258 8.67418C10.9742 8.32254 10.4973 8.125 10 8.125C9.50272 8.125 9.02581 8.32254 8.67418 8.67418C8.32254 9.02581 8.125 9.50272 8.125 10C8.125 10.4973 8.32254 10.9742 8.67418 11.3258C9.02581 11.6775 9.50272 11.875 10 11.875Z",
    fill: "#868C98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.45fd30022db6ad0ed9d396d84f0aa410.svg";
export { ForwardRef as ReactComponent };